export default __webpack_public_path__ + "static/14-245604b5ec9fe0f0b01a7d55ccccf78c.png";